import React from 'react';
import { TwoFaMethod } from 'shared/components';
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';

import { RESEND_2FA, RESEND_2FA_BY_EMAIL } from 'graphql/mutations/user';
import { ToastBody } from 'components';
import { TWO_FA_METHODS } from 'shared/enums';

export default ({ token, t, handleCallback }) => {
  const [resend2faByEmail] = useMutation(RESEND_2FA_BY_EMAIL);
  const [resend2fa] = useMutation(RESEND_2FA);

  const handleResendByEmail = async () => {
    try {
      await resend2faByEmail({
        variables: {
          token
        },
        onCompleted: () => {
          toast.success(
            <ToastBody
              data-pendoid="signin_send_2fa_email"
              category="success"
              title={t?.('signin_2fa_email_title')}
              text={t?.('signin_2fa_email_message')}
            />
          );
          handleCallback(TWO_FA_METHODS.EMAIL);
        }
      });
    } catch (error) {
      toast.error(
        <ToastBody
          data-pendoid="signin_invalid_2fa_email"
          category="error"
          title={t?.('signin_invalid_2fa_email_title')}
          text={t?.('signin_invalid_2fa_phone_message')}
        />
      );
    }
  };

  const handleSend2fa = async preferred2Fa => {
    if (preferred2Fa === TWO_FA_METHODS.EMAIL) {
      handleResendByEmail();
    } else {
      try {
        await resend2fa({
          variables: {
            token,
            overrideMethod: preferred2Fa
          },
          onCompleted: () => {
            toast.success(
              <ToastBody
                category="success"
                title={t?.('signup_confirmation_title')}
                text={t?.('signin_2fa_email_title')}
              />
            );
            handleCallback(preferred2Fa);
          }
        });
      } catch (error) {
        toast.error(
          <ToastBody
            data-pendoid="signin_invalid_2fa_phone"
            category="error"
            title={t?.('signin_invalid_2fa_phone_title')}
            text={t?.('signin_invalid_2fa_phone_message')}
          />
        );
        handleCallback(preferred2Fa);
      }
    }
  };

  return <TwoFaMethod handleSubmit={handleSend2fa} />;
};
